import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Rate, Row, Table, Typography } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";

const { Title } = Typography;

const ListFeedback = (props) => {
  const [list, setList] = useState(null);
  const { locations, lot } = props;

  const componentRef = useRef();

  useEffect(() => {
    locations && prepareList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locations]);

  function prepareList() {
    const myList = locations
      .filter((item) => item.location_lot.lot_id === lot.lot_id && item.location_etat !== "a")
      .flatMap((location) =>
        location.feedbacks.map((feedback) => ({
          ...feedback,
          langue: feedback.langue.libelle,
          lot: location.location_lot.lot_reference,
        }))
      );
    setList(myList.sort((a, b) => b.id - a.id));
  }

  let columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Sélection",
      dataIndex: "selection",
      key: "selection",
      render: (selection) => selection && <CheckOutlined />,
      align: "right",
      width: "5%",
    },
    {
      title: "Titre",
      dataIndex: "titre",
      key: "titre",
      width: "10%",
    },
    {
      title: "Libelle",
      dataIndex: "libelle",
      key: "libelle",
      width: "10%",
    },
    {
      title: "Note",
      dataIndex: "note",
      key: "note",
      width: "15%",
      render: (note) => <Rate disabled value={note} />,
    },
    {
      title: "Détail",
      dataIndex: "texte",
      key: "texte",
      width: "40%",
      autoSize: { minRows: 3, maxRows: 3 },
    },
    {
      title: "Langue",
      dataIndex: "langue",
      key: "langue",
      width: "10%",
    },
    {
      title: "Lot",
      dataIndex: "lot",
      key: "lot",
      align: "right",
      width: "10%",
    },
  ];

  return (
    <>
      <div style={{ padding: 20 }}>
        <Row>
          <Title level={2}>Liste des Feedback</Title>
        </Row>
      </div>
      <div ref={componentRef}>
        {list && (
          <Row gutter={12}>
            <Col span={22}>
              <Table
                className="list-data"
                dataSource={list}
                columns={columns}
                pagination={false}
                rowKey="id"
              />
            </Col>
            <Col span={2}>
              <Button>
                <CSVLink
                  filename={"export.csv"}
                  data={list}
                  //headers={headers()}
                  separator={";"}
                >
                  Export CSV
                </CSVLink>
              </Button>
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};

export default ListFeedback;
